import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const LoginGuard = () => {

    let authSelector = useSelector(state=>state.authReducer)
    /* Check for the token 
        - if the token is present then navigate user to the dashboard.
        - if user is navigating to the login route and if there is no token 
            - then navigate user to the login page.
    */
    let auth = { 'token': authSelector.token };
    return (
        !auth.token ? <Outlet /> : <Navigate to='/' />
    )
}

export default LoginGuard;